
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","width":"32pt","height":"32pt","viewBox":"0 0 32 32"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M13.684 4.285l-.227.688A8.972 8.972 0 0013 7.785c0 4.293 3.035 7.899 7 8.426v5.8L13.387 16H8.648l-.277.223s-2.453 1.976-3.34 5.535c-.699 2.785 0 5.48 0 5.48l.184.762h21.37l-1.913-1.738L22 23.828v-7.617c3.965-.527 7-4.133 7-8.426 0-.992-.168-1.933-.457-2.812l-.227-.688zm1.562 2h11.508c.113.492.246.973.246 1.5 0 3.637-2.715 6.5-6 6.5s-6-2.863-6-6.5c0-.527.133-1.008.246-1.5zM10.496 18h2.117l8.801 8h-2.027zm-1.934.953L16.392 26H6.863c-.129-.781-.293-2.16.106-3.758.386-1.539 1.039-2.59 1.593-3.289z"}})])
          )
        }
      }
    